// useClanInvitation.ts
import { useEffect } from 'react';
import { STORAGE_KEYS } from '../utils';

const key = STORAGE_KEYS.clanInvitation ?? '';

/**
 * Guarda el código de invitación si existe en la URL.
 * Si cambia, actualiza el localStorage automáticamente.
 */
export function useClanInvitation() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const params = new URLSearchParams(window.location.search);
    const invitation = params.get(key);

    if (!invitation) return;

    const currentStored = localStorage.getItem(key);

    // Solo actualiza si es diferente
    if (currentStored !== invitation) {
      localStorage.setItem(key, invitation);
    }
  }, []);
}

/**
 * Obtiene el código guardado.
 */
export function getClanInvitation(): string | null {
  if (typeof window === 'undefined') return null;

  return localStorage.getItem(key);
}

/**
 * Borra el código guardado.
 */
export function clearClanInvitation(): void {
  if (typeof window === 'undefined') return;

  localStorage.removeItem(key);
}
